export default __webpack_public_path__ + "static/media/BSCX-BNB.e43140c8.svg";